module.exports = __webpack_public_path__ + "img/conveniencias-06.b6ba9eaa.png";